

























import { Component, Prop, Vue } from 'vue-property-decorator';

import StatTile from '@/components/common/StatTile.vue';

import { SurveySite } from '@/api';

@Component({
  components: {
    StatTile,
  },
})
export default class PropertyOverview extends Vue {
  @Prop({ required: true }) readonly site: SurveySite;
}
